import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { FeesSetObj } from "../../utils/types";

const initialState: FeesSetObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getFeesSetByID = createAsyncThunk(
  "loans/getFeesSet",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const feesSetByIDSlice = createSlice({
  name: "feesSet",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeesSetByID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFeesSetByID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getFeesSetByID.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default feesSetByIDSlice.reducer;
